import { API, graphqlOperation } from "aws-amplify";

import { carrierUserByEmailMini } from "../../../graphql/carrier/carrier-queries";
import {
  customerByEmailMini,
  userByEmailMini,
} from "../../../graphql/reloadyard/custom-queries";
import { logError } from "../../../utils/appUtils";
import { UserType, UserTypeOptions } from "../../../utils/constants";

export const validateEmailUnicity = async (form, notify = false) => {
  const formState = form.getState();
  const allValues = formState.values;
  const email = allValues?.email;

  if (!email) {
    form.mutators.setFieldData("email", { error: undefined });
    return false;
  }

  // if not dirty on edit, skip validation
  if (allValues?.id && !formState?.dirtyFields?.email) {
    return false;
  }

  try {
    const [customerResp, userResp, carrierResp] = await Promise.all([
      API.graphql(graphqlOperation(customerByEmailMini, { email })),
      API.graphql(graphqlOperation(userByEmailMini, { email })),
      API.graphql(graphqlOperation(carrierUserByEmailMini, { email })),
    ]);

    const duplicateCustomer = customerResp.data.customerByEmail.items[0];
    const duplicateUser = userResp.data.userByEmail.items[0];
    const duplicateCarrier = carrierResp.data.carrierUserByEmail.items[0];

    // Active user/customer/carrier collision -> blocking duplicate.
    // Inactive user in a different yard -> cannot reactivate across yards.
    // Inactive user in same yard -> reactivation handled by save flow; no inline error.
    let error;
    if (duplicateCustomer) {
      error = "User with this email already exists.";
    } else if (duplicateUser?.active === "true") {
      error = "User with this email already exists.";
    } else if (
      duplicateUser &&
      duplicateUser.reloadYardId !== window.appUser.reloadYardId
    ) {
      error = "Cannot reactivate a user in different reload Yard";
    } else if (
      duplicateCarrier?.reloadYardCarriers?.items?.some(
        (itm) => itm.active === "true",
      )
    ) {
      error = "User with this email already exists.";
    }

    form.mutators.setFieldData("email", { error });
    return !!error;
  } catch (error) {
    logError("users:userUtils:validateEmailUnicity", error, notify);
    if (notify) throw error;
    return false;
  }
};

export const getUserTypeDescription = (userType) => {
  const userTypeOption = UserTypeOptions.find((itm) => itm.id === userType);
  return userTypeOption ? userTypeOption.description : false;
};

export const getUserTypeOptions = (userRecord) => {
  if (window.appUser?.type === UserType.MANAGER) {
    return UserTypeOptions; // MANAGER can edit all users
  }
  if (
    window.appUser?.type === UserType.SUPERVISOR &&
    userRecord?.type !== UserType.MANAGER
  ) {
    return UserTypeOptions.filter((itm) => itm.id !== UserType.MANAGER); // SUPERVISOR can edit CREW & SUPERVISOR
  }
  return UserTypeOptions; // SUPERVISOR editing a MANAGER, show all radio buttons disabled
};

export const disableUserOptions = (userRecord) => {
  // return false;
  return (
    window.appUser.id === userRecord?.id ||
    (window.appUser.type !== UserType.MANAGER &&
      userRecord?.type === UserType.MANAGER)
  );
};
